import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { AuthService } from './auth.service';
import { CartService } from 'app/services/cart/cart.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private cartService: CartService,
    private router: Router,
  ) {}

  canActivate(): boolean {
    if (this.authService.isLoggedIn()) return true;

    this.clearEverything();
    this.router.navigate(['auth/login']);
    return false;
  }

  clearEverything() {
    this.cartService.clearCart();
    localStorage.clear();
    sessionStorage.clear();
  }

}
